import $ from 'jquery';
import objectAssign from 'object-assign';

export default function () {
  const $sliders = $('.slider');
  const defaultOptions = {
    // Custom options are set inline
    dots: true,
    arrows: false,
  };

  $sliders.each(function () {
    const $slider = $(this);
    const inlineOptions = $slider.attr('data-slick');
    const mergedOptions = inlineOptions
      ? objectAssign({}, defaultOptions, JSON.parse(inlineOptions))
      : defaultOptions;
    $slider.slick(mergedOptions);
  });
}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/slider.js